import Util from "./util/main";
import UI from "./ui/main";
export default class Main {
    constructor() {
        this.ui = new UI();
        this.util = new Util();
    }
}
